module.exports = __webpack_public_path__ + "static/media/redes_sociales.7a56e004.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/redes_sociales.gif
// module id = 70
// module chunks = 0